/**
 * @description 权限点字典
 */
export const PERMISSION_TEXT = {
    'indonesia_idcard_quality': 'e-KTP Quality Detection',
    'indonesia_ocridcard': 'e-KTP Recognition',
    'indonesia_ocridcard_plus': 'e-KTP Recognition Advanced',
};


/**
 * @description appkey 权限点原始树
 */
export const PERMISSION_ORIGIN_TREE = [
    {   value: 'face_verify', label: '人脸比对', key: 'face_verify',
        children: [
            {value: 'verify_3', label: '调用Verify API3.0', key: 'face_verify-verify_3',
                children: [

                ]
            }
        ]
    },
    { value: 'ocr', label: 'Certificate Recognition', key: 'ocr',
        children: [
            {value: 'indonesia_idcard_quality', label: PERMISSION_TEXT['indonesia_idcard_quality'], key: 'ocr-indonesia_idcard_quality'},
            {value: 'indonesia_ocridcard', label: PERMISSION_TEXT['indonesia_ocridcard'], key: 'ocr-indonesia_ocridcard'},
            {value: 'indonesia_ocridcard_plus', label: PERMISSION_TEXT['indonesia_ocridcard_plus'], key: 'ocr-indonesia_ocridcard_plus'}
        ]
    }
];


/**
 * @description 根据已有权限点筛选appkey原始权限点树
 * @param {array} permissions 权限点列表
 * @param {array} origin_tree 权限树
 */
export function searchPermissionTree(permissions, origin_tree) {
    const permissions_tree = [];
    origin_tree.forEach(item=> {
        if (item.children) {
            const sub_tree = searchPermissionTree(permissions, item.children);
            if (sub_tree.length > 0) {
                item.children = sub_tree;
                permissions_tree.push(item);
            }
        }else {
            if(permissions.indexOf(item.value) > -1) {
                permissions_tree.push(item);
            }
        }
    });
    return permissions_tree;
}

/**
 * @description 整理得到appkey权限点平铺后的数组
 * @param {object} permission 包含权限点的json对象
 */
export function expandPermissionObject(permission) {
    let permissions = [];
    for (const key in permission) {
        if (permission.hasOwnProperty(key)) {
            const element = permission[key];
            permissions = permissions.concat(element);

        }
    }
    return permissions;
}



// WEBPACK FOOTER //
// ./src/pages/Appkey/const.js